import type { ImageOps } from "../types";

// Dynamic import for WASM sharp to handle optional dependency
let sharpWasm: any = null;
try {
  sharpWasm = require("@img/sharp-wasm");
} catch (error) {
  // Sharp WASM not available
}

export const edgeImageOps: ImageOps = {
  async svgToPng(svg: string): Promise<string> {
    if (!sharpWasm) {
      // Fall back to SVG data URL when Sharp WASM is not available
      console.warn("Sharp WASM not available, falling back to SVG format");
      return `data:image/svg+xml;base64,${Buffer.from(svg).toString("base64")}`;
    }
    const png = await sharpWasm(Buffer.from(svg)).png().toBuffer();
    return `data:image/png;base64,${png.toString("base64")}`;
  },

  isAvailable(): boolean {
    return sharpWasm !== null;
  },
};

// Runtime guard
if (
  typeof (globalThis as any).EdgeRuntime === "undefined" &&
  typeof process !== "undefined" &&
  process.versions?.node
) {
  throw new Error(
    "DataShows SDK: Edge adapter loaded in Node runtime. Use `datashows-sdk/node` or ensure your bundler picks the correct entry point."
  );
}
